/**
 * Comprehensive list of HTML tags for CSS extraction.
 * This list is used by both the client-side and server-side CSS extraction processes
 * to ensure consistent styling of elements inside shadow DOM.
 */

export const HTML_TAGS = [
  'a',
  'abbr',
  'address',
  'area',
  'article',
  'aside',
  'audio',
  'b',
  'bdo',
  'blockquote',
  'body',
  'br',
  'button',
  'canvas',
  'caption',
  'cite',
  'code',
  'col',
  'colgroup',
  'data',
  'datalist',
  'dd',
  'del',
  'details',
  'dfn',
  'dialog',
  'div',
  'dl',
  'dt',
  'em',
  'embed',
  'fieldset',
  'figcaption',
  'figure',
  'footer',
  'form',
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6',
  'head',
  'header',
  'hgroup',
  'hr',
  'html',
  'i',
  'iframe',
  'img',
  'input',
  'ins',
  'kbd',
  'label',
  'legend',
  'li',
  'link',
  'main',
  'map',
  'mark',
  'math',
  'menu',
  'menuitem',
  'meta',
  'meter',
  'nav',
  'noscript',
  'object',
  'ol',
  'optgroup',
  'option',
  'output',
  'p',
  'param',
  'picture',
  'portal',
  'pre',
  'progress',
  'q',
  'rp',
  'rt',
  'ruby',
  's',
  'samp',
  'script',
  'section',
  'select',
  'slot',
  'small',
  'source',
  'span',
  'strong',
  'style',
  'sub',
  'summary',
  'sup',
  'svg',
  'table',
  'tbody',
  'td',
  'template',
  'textarea',
  'tfoot',
  'th',
  'thead',
  'time',
  'title',
  'tr',
  'track',
  'u',
  'ul',
  'var',
  'video',
  'wbr',
];

/**
 * Checks if a selector is a valid tag selector or a tag with a pseudo-class.
 *
 * @param selector The CSS selector to check
 * @returns True if the selector is a valid tag selector
 */
export function isTagSelector(selector: string): boolean {
  // Trim whitespace
  selector = selector.trim();

  // Check if it's a comma-separated list
  if (selector.includes(',')) {
    // Split by comma and check if at least one part is a tag selector
    return selector
      .split(',')
      .map((part) => part.trim())
      .some((part) => isTagSelector(part));
  }

  // Check for pseudo-classes
  const hasPseudoClass = selector.includes(':');

  if (hasPseudoClass) {
    // Extract the base selector (before the pseudo-class)
    const baseSelectorMatch = selector.match(/^([a-zA-Z][a-zA-Z0-9]*)/);
    if (!baseSelectorMatch || !baseSelectorMatch[1]) return false;

    const baseSelector = baseSelectorMatch[1];
    return HTML_TAGS.includes(baseSelector);
  }

  // Simple tag selector check
  return HTML_TAGS.includes(selector);
}
